import { jsx as _jsx } from "react/jsx-runtime";
import { EndDayButton } from './end-day-button';
import { TECHNICIAN } from '../../../Authentication/constants';
import styled from 'styled-components';
import spacing from 'theme/spacing';
const WorkOrderListBottomContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 640px;
  margin: auto 0 ${spacing.spacing16};
`;
const WorkOrderListBottomButtons = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: calc(100% - 10px);
  padding: 0 5px;
`;
export const WorkOrderListBottom = ({ endDayFunction, role, }) => {
    return (_jsx(WorkOrderListBottomContainer, { children: role === TECHNICIAN && (_jsx(WorkOrderListBottomButtons, { children: _jsx(EndDayButton, { endDayFunction: endDayFunction }) })) }));
};
